import * as React from "react";
import { UitkButtonToggleGroup, UitkButtonToggleGroupProps } from "uitk-react-button-toggle";
import { classNames } from "uitk-react-utils";

export const ButtonToggleGroup: React.FC<UitkButtonToggleGroupProps> = ({ className: customClassName, ...props }) => {
  const className = classNames(customClassName, "uitk-flex uitk-flex-wrap");

  return <UitkButtonToggleGroup {...props} className={className} />;
};

export default ButtonToggleGroup;
